import { useMemo } from "react";
import { subHours } from "date-fns";
import { toISODateString, type ISODateString } from "@visioni/a3s-codecs";
import { type AppStateStatus } from "react-native";

type UseTimezonedBoundsReturn = {
  startTime: ISODateString;
  endTime: ISODateString;
};

export function useTimezonedBounds(_timezone: string, appState: AppStateStatus): UseTimezonedBoundsReturn {
  // eslint-disable-next-line react-hooks/exhaustive-deps -- appState is intentional: cache-bust on foreground
  const now = useMemo(() => new Date(), [appState]);

  const startTime = useMemo(() => toISODateString(subHours(now, 24)), [now]);
  const endTime = useMemo(() => toISODateString(now), [now]);

  return {
    startTime,
    endTime,
  };
}
